import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import useSEO from "@/lib/useSEO";
import { ArrowLeft, MapPin, Calendar, Tag, Building2, CheckCircle2 } from "lucide-react";

export default function ProjeDetay() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [active, setActive] = useState(0);
  const [notFound, setNotFound] = useState(false);

  useSEO({
    title: project?.title || "Proje Detayı",
    description: project?.description?.slice(0, 160) || "YK İnşaat proje detayı.",
    path: `/projeler/${id}`,
  });

  useEffect(() => {
    api.get(`/projects/${id}`).then((r) => setProject(r.data)).catch(() => setNotFound(true));
  }, [id]);

  const getImg = (p) => (p?.startsWith("http") ? p : fileUrl(p));

  if (notFound) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center px-6 text-center">
        <div className="section-label mb-4">404</div>
        <h1 className="font-heading text-3xl text-white mb-6">Proje bulunamadı</h1>
        <Link to="/projeler" className="btn-gold-outline">← Projelere Dön</Link>
      </div>
    );
  }

  if (!project) return <div className="min-h-[60vh] flex items-center justify-center text-[#C9A961] tracking-widest text-sm uppercase">Yükleniyor...</div>;

  return (
    <div className="min-h-screen bg-[#0A0E1A]" data-testid="project-detail">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <Link to="/projeler" className="inline-flex items-center gap-2 text-white/60 hover:text-[#C9A961] text-xs uppercase tracking-[0.2em] mb-8">
          <ArrowLeft className="w-4 h-4" /> Projelere Dön
        </Link>

        <div className="grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-3">
            <div className="aspect-[4/3] overflow-hidden bg-[#111827] border border-[#1F2937] mb-4">
              {project.images?.[active] ? (
                <img src={getImg(project.images[active])} alt={project.title} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-[#1F2937]"><Building2 className="w-24 h-24" /></div>
              )}
            </div>
            {project.images?.length > 1 && (
              <div className="grid grid-cols-4 gap-3">
                {project.images.map((img, i) => (
                  <button key={i} onClick={() => setActive(i)} className={`aspect-square overflow-hidden border-2 transition-colors ${active === i ? "border-[#C9A961]" : "border-[#1F2937]"}`}>
                    <img src={getImg(img)} alt="" className="w-full h-full object-cover" />
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="lg:col-span-2">
            <div className="section-label mb-4">{project.category}</div>
            <h1 className="font-heading text-3xl lg:text-4xl text-white tracking-[0.05em] leading-tight mb-6">{project.title}</h1>

            <div className="space-y-4 mb-8 pb-8 border-b border-[#1F2937]">
              {project.location && (
                <div className="flex items-center gap-3 text-white/70"><MapPin className="w-4 h-4 text-[#C9A961]" strokeWidth={1.5} /> <span>{project.location}</span></div>
              )}
              {project.year && (
                <div className="flex items-center gap-3 text-white/70"><Calendar className="w-4 h-4 text-[#C9A961]" strokeWidth={1.5} /> <span>{project.year}</span></div>
              )}
              <div className="flex items-center gap-3 text-white/70"><Tag className="w-4 h-4 text-[#C9A961]" strokeWidth={1.5} /> <span>{project.category}</span></div>
              <div className="flex items-center gap-3 text-white/70"><CheckCircle2 className="w-4 h-4 text-[#C9A961]" strokeWidth={1.5} /> <span>{project.status}</span></div>
            </div>

            {project.description && (
              <>
                <div className="section-label mb-3">Proje Hakkında</div>
                <p className="text-white/70 leading-relaxed whitespace-pre-line">{project.description}</p>
              </>
            )}

            <Link to="/iletisim" className="mt-10 btn-gold w-full">Bilgi Al</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
